import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VCard,
    [
      _c(VCardTitle, { attrs: { "primary-title": "" } }, [
        _c("div", { staticClass: "H5-Primary-Left" }, [_vm._v("Brand Config")])
      ]),
      _c(
        "div",
        { staticClass: "v-card-content" },
        [
          _c(
            VLayout,
            { attrs: { wrap: "" } },
            [
              _c(
                VFlex,
                [
                  _c(
                    VFlex,
                    {
                      attrs: {
                        xs12: "",
                        "display-flex": "",
                        wrap: "",
                        "pl-0": ""
                      }
                    },
                    [
                      _c(VCheckbox, {
                        staticClass: "mt-0",
                        attrs: {
                          label: "Allow Menu Assignation",
                          value: _vm.customPermissions.assignBrandMenus,
                          disabled: !_vm.canGiveAssignBrandMenus
                        },
                        model: {
                          value: _vm.permissions.scopes,
                          callback: function($$v) {
                            _vm.$set(_vm.permissions, "scopes", $$v)
                          },
                          expression: "permissions.scopes"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                VFlex,
                [
                  _c(
                    VFlex,
                    {
                      attrs: {
                        xs12: "",
                        "display-flex": "",
                        wrap: "",
                        "pl-0": ""
                      }
                    },
                    [
                      _c(VCheckbox, {
                        staticClass: "mt-0",
                        attrs: {
                          label: "Allow Timeslot Modification",
                          value: _vm.customPermissions.editBrandTimeslots,
                          disabled: !_vm.canGiveEditBrandTimeslots
                        },
                        model: {
                          value: _vm.permissions.scopes,
                          callback: function($$v) {
                            _vm.$set(_vm.permissions, "scopes", $$v)
                          },
                          expression: "permissions.scopes"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }